import { DeviceDetails, RoleAttributes, AccessLevels } from './telosair-interfaces';

/**
 * GenerateDummyData function.
 * @returns - Array.
 */
export const generateDummyData = (): number[] =>
  new Array(12).fill(0).map(() => Math.floor(Math.random() * 50 + 50));

export const TEMP_DATA_ROLES: RoleAttributes[] = [
  {
    type: 'Alerts',
    data: [
      {
        type: 'Raise alerts',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.full,
          observer: AccessLevels.full
        }
      },
      {
        type: 'Take action on alerts',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.full,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Assign alerts',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Dismiss alert',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      }
    ]
  },
  {
    type: 'Reports',
    data: [
      {
        type: 'Manage report',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Request report',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Standard report',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Raw data report',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Alerts report',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Analytics report',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Request custom report',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      }
    ]
  },
  {
    type: 'Data',
    data: [
      {
        type: 'View Analytics',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Export data',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Add notes to devices',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Floor view',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Table view',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      }
    ]
  },
  {
    type: 'Parameters',
    data: [
      {
        type: 'Manage configurations',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Change units for user',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      }
    ]
  },
  {
    type: 'User management',
    data: [
      {
        type: 'Manage Admins',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Add/invite users',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Create roles',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Change roles',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      }
    ]
  },
  {
    type: 'TelosAir account',
    data: [
      {
        type: 'Manage Admins',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Add/invite users',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      }
    ]
  },
  {
    type: 'Device setup',
    data: [
      {
        type: 'Manage devices',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Configure gateway',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      },
      {
        type: 'Manage group',
        permissions: {
          owner: AccessLevels.full,
          administrator: AccessLevels.full,
          operator: AccessLevels.view,
          observer: AccessLevels.view
        }
      }
    ]
  }
];

export const deviceDataArray: DeviceDetails[] = [
  {
    deviceName: 'KBA S1',
    id: 43221,
    model: 'Model v3 Duet',
    dataRate: 91,
    gatewayId: 12,
    connectionStatus: 'Wifi',
    configuration: 'Temp Config 2'
  },
  {
    deviceName: 'KBA S2',
    id: 43222,
    model: 'Model v4 Duet',
    dataRate: 92,
    gatewayId: 13,
    connectionStatus: 'Wifi',
    configuration: 'Temp Config 23'
  },
  {
    deviceName: 'KBA S3',
    id: 43223,
    model: 'Model v5 Duet',
    dataRate: 93,
    gatewayId: 14,
    connectionStatus: 'Data',
    configuration: 'Temp Config 12'
  },
  {
    deviceName: 'KBA S4',
    id: 43224,
    model: 'Model v6 Duet',
    dataRate: 94,
    gatewayId: 15,
    connectionStatus: 'Wifi',
    configuration: 'Temp Config 25'
  },
  {
    deviceName: 'KBA S5',
    id: 43225,
    model: 'Model v7 Duet',
    dataRate: 95,
    gatewayId: 16,
    connectionStatus: 'Data',
    configuration: 'Temp Config 33'
  },
  {
    deviceName: 'KBA S6',
    id: 43226,
    model: 'Model v8 Duet',
    dataRate: 96,
    gatewayId: 17,
    connectionStatus: 'Wifi',
    configuration: 'Temp Config 6'
  },
  {
    deviceName: 'KBA S7',
    id: 43227,
    model: 'Model v9 Duet',
    dataRate: 97,
    gatewayId: 18,
    connectionStatus: 'Data',
    configuration: 'Temp Config 08'
  },
  {
    deviceName: 'KBA S8',
    id: 43228,
    model: 'Model v10 Duet',
    dataRate: 98,
    gatewayId: 19,
    connectionStatus: 'Wifi',
    configuration: 'Temp Config 25'
  }
];

export const configuration = [
  {
    configurationId: 1,
    configurationName: 'ASHRAE'
  },
  {
    configurationId: 2,
    configurationName: 'IECC'
  }
];

// export const USER_DATA: UserDetails[] = [
//   {
//     name: 'Abijith K',
//     email: 'abijithk9571@gmail.com',
//     id: 1,
//     role: 'Admin',
//     status: 'Active',
//     lastActive: '2h ago'
//   },
//   {
//     name: 'Aviral V',
//     email: 'aviral1234@gmail.com',
//     id: 2,
//     role: 'Guest',
//     status: 'Active',
//     lastActive: '2h ago'
//   },
//   {
//     name: 'Anudeep B',
//     email: 'anudeep9999@gmail.com',
//     id: 3,
//     role: 'User',
//     status: 'Active',
//     lastActive: '2h ago'
//   },
//   {
//     name: 'Harish M',
//     email: 'harishm890@gmail.com',
//     id: 4,
//     role: 'Admin',
//     status: 'Active',
//     lastActive: '2h ago'
//   },
//   {
//     name: 'Jake Ryan',
//     email: 'heller.will@yahoo.com.au',
//     id: 5,
//     role: 'Admin',
//     status: 'Active',
//     lastActive: '2h ago'
//   },
//   {
//     name: 'Hemanth K',
//     email: 'abijithk9571@gmail.com',
//     id: 6,
//     role: 'Client',
//     status: 'Active',
//     lastActive: '2h ago'
//   },
//   {
//     name: 'Thomas Lee',
//     email: 'camden32@kertzmann.com ',
//     id: 7,
//     role: 'Admin',
//     status: 'Active',
//     lastActive: '2h ago'
//   },
//   {
//     name: 'Hazel Miller',
//     email: 'tlockman@hotmail.com',
//     id: 8,
//     role: 'Admin',
//     status: 'Active',
//     lastActive: '2h ago'
//   }
// ];

export const CONTOUR_DATA = [
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8,
    group: 'A'
  },
  {
    x: 12,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 13,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 6.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 6.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 6.8,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 6.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 5.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 6.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 13.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 6.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 6.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 6.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 7.4,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.9,
    y: 5.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 7.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 13,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 13.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 6.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 13.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 6.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 6.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9,
    group: 'A'
  },
  {
    x: 11,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 13.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 6.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 12,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 6.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 6.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 13.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12,
    y: 12,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 6.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 12,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 13.7,
    group: 'A'
  },
  {
    x: 14,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 6.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.1,
    y: 13.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.3,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 13.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 13.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 13.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8,
    group: 'A'
  },
  {
    x: 14,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10,
    group: 'A'
  },
  {
    x: 12.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 6.7,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 14.8,
    y: 10,
    group: 'A'
  },
  {
    x: 7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 12,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.7,
    group: 'A'
  },
  {
    x: 12,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 5.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 13.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 13.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.1,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 12,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12,
    group: 'A'
  },
  {
    x: 8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 6.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 13,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.8,
    group: 'A'
  },
  {
    x: 5.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 6.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 13,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 6.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 6.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 13.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 12.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 6.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 7.7,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 12.8,
    group: 'A'
  },
  {
    x: 6.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 13,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 12,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 13.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.7,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 13.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.9,
    group: 'A'
  },
  {
    x: 7.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 13.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 13.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 6.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 13.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 13,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 13,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 13,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 6.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 12,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 13,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 6.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.5,
    group: 'A'
  },
  {
    x: 5.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 13.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 13,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.5,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 13,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 13.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8,
    group: 'A'
  },
  {
    x: 6.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.4,
    group: 'A'
  },
  {
    x: 13.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 13.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11,
    group: 'A'
  },
  {
    x: 6.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 13.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 6.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 6.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 6.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 6.6,
    y: 11,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 12.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 6.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11,
    group: 'A'
  },
  {
    x: 7.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 13.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 13.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.7,
    group: 'A'
  },
  {
    x: 12,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 6.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 13.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 5.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 13.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 13.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 7.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 13.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 6.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 13.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 6.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 14.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 13.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 13.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 13.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 6.9,
    group: 'A'
  },
  {
    x: 11,
    y: 8.4,
    group: 'A'
  },
  {
    x: 6.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 14.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 13.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 13.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 12,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 6.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.4,
    y: 12.5,
    group: 'A'
  },
  {
    x: 7.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 12,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 12,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.4,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 13.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 13.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 6.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 13.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 13.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 13.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 7.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 6.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 6.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.7,
    y: 6.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 13.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 13,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 13,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 13.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 6.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 7.2,
    y: 12,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 13,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 13,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 14.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 13.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12,
    y: 13,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 6.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 13.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 6.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 6.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 12.5,
    group: 'A'
  },
  {
    x: 6.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.9,
    group: 'A'
  },
  {
    x: 11,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 6.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 13.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 6.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10,
    y: 12,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 6.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 13.3,
    group: 'A'
  },
  {
    x: 9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8,
    group: 'A'
  },
  {
    x: 12.9,
    y: 13,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7,
    y: 12,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 13.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 6.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 6.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 13,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 6.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 6.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 6.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 7.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 6.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 6.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 6.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 13.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 6.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 7,
    y: 8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 6.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 6.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 14.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11,
    group: 'A'
  },
  {
    x: 12,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 13.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 6.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 13.6,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 13.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 6.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 6.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 13,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 13,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.4,
    group: 'A'
  },
  {
    x: 12,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 13,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 13.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 12.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.7,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 6.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 7.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 13,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 5.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 11.7,
    y: 12,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 13,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 13.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 13.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 7,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8,
    y: 12.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.3,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 13,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 12,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 7.2,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8,
    y: 8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 12,
    group: 'A'
  },
  {
    x: 13.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 6.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 6.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 6.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 12,
    y: 9.6,
    group: 'A'
  },
  {
    x: 13.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 12,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 6.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 13.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 12,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 13,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 13,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 13,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 13.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.4,
    y: 7.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 7,
    group: 'A'
  },
  {
    x: 6.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.9,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 12,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 13,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.7,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 6.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 13,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8,
    group: 'A'
  },
  {
    x: 10,
    y: 6.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 12,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 6.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 13.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 13.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 13.4,
    y: 11,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 13.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 6.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12,
    y: 12,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.7,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 5.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 13.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 12,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.7,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 12,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 13.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 12,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 13.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.2,
    group: 'A'
  },
  {
    x: 13.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 13.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 13.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 6.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 13.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 7.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8,
    group: 'A'
  },
  {
    x: 12,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 7.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11,
    y: 7.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 14.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 12,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 7.2,
    y: 8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 6.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 13.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 13.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 6.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 13.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.2,
    group: 'A'
  },
  {
    x: 13.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.5,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 12.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12,
    y: 12.1,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 12,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 12,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 12,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 13.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 6.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 12,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 6.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8,
    group: 'A'
  },
  {
    x: 11,
    y: 6.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 5.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 6.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 13.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 13.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 6.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10,
    y: 12,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 12,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 13.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 5.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 13.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 12,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 13.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 13,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.7,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 6,
    group: 'A'
  },
  {
    x: 11,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12,
    group: 'A'
  },
  {
    x: 7.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 13.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 5.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 6.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 13.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 6.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 6.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11,
    group: 'A'
  },
  {
    x: 6.3,
    y: 8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 13.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 14.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 6.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 6.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.1,
    group: 'A'
  },
  {
    x: 6.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 6.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 6.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.3,
    y: 7.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 6.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 6.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 14,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 6.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 13,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 13.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 13.2,
    group: 'A'
  },
  {
    x: 9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 13.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 13,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 6.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 14.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8,
    group: 'A'
  },
  {
    x: 9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 12,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.6,
    y: 13.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.5,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 13.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 12,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 6.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 6.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.6,
    y: 13,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 6.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 6.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 13.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 13.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 14.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 6.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 13,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 5.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.9,
    y: 13.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 13.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 13,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 13.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.1,
    y: 12,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 13,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 12.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 13.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 13,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 13.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 13,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 6.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 6.8,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 13.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 6.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 13.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.2,
    y: 6.9,
    group: 'A'
  },
  {
    x: 12.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 12.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 7.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 6.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 12,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 6.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8,
    group: 'A'
  },
  {
    x: 11,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 13.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 12,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.5,
    y: 13.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 12.8,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 6.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 6.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 6.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 13.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 6.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 12,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 13.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 6.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 13.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 13.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 13.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.5,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 6.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 13,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 13.5,
    y: 10,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.2,
    group: 'A'
  },
  {
    x: 6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 13.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 6.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 6.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11,
    group: 'A'
  },
  {
    x: 8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 14,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12,
    y: 8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 6.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 13.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 6.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 13,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 13.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 12,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 7.4,
    group: 'A'
  },
  {
    x: 8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 12.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 13.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 7.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 12,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 7.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 13,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12,
    y: 10,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 13,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 13.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.5,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 6.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 13,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 13.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.3,
    y: 13.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 13.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 13,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 14.2,
    y: 11,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 12,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 6.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 13,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 7.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 12,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 6.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12,
    group: 'A'
  },
  {
    x: 12.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 6.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 13.2,
    y: 11,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 6.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 12,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 6.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 13,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11,
    group: 'A'
  },
  {
    x: 13.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 13.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 12,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 12,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 13,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 12,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 13.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 13.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 6.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 12,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 13.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.8,
    group: 'A'
  },
  {
    x: 12,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.4,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 13,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 13,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 13,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 13.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 6,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 13.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 13.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 6.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 13.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.2,
    group: 'A'
  },
  {
    x: 13.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 6.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 6.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.6,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12,
    y: 12,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 10.2,
    y: 13.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 12,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9,
    y: 7,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.6,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 6.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.7,
    group: 'A'
  },
  {
    x: 13.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 6.5,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 6.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 6.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 13,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 7.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.3,
    group: 'A'
  },
  {
    x: 6.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 6.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 6.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 13.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 13,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 6.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10,
    y: 7.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 13.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 6.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 13.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 13.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 13,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 6.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 13.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 6.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 13.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 13.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 13,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 13,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 13.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 12,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 13.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 13.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 6.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 6.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 13,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 6.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 6.6,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 13,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 11.8,
    y: 12,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8,
    group: 'A'
  },
  {
    x: 14,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 7.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 12.4,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 13.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11,
    group: 'A'
  },
  {
    x: 7.8,
    y: 6.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12,
    y: 11,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 6.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 6.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 13.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10,
    group: 'A'
  },
  {
    x: 13.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.7,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.9,
    group: 'A'
  },
  {
    x: 13.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 12,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12.1,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 13.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 6.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 6.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.4,
    group: 'A'
  },
  {
    x: 13.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 7.9,
    group: 'A'
  },
  {
    x: 12,
    y: 13,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 6.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 13,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 7.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 9,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 12.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11,
    y: 12,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 5.7,
    group: 'A'
  },
  {
    x: 13.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9,
    group: 'A'
  },
  {
    x: 6.5,
    y: 12.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 7.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.8,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 6.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 13.2,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12,
    group: 'A'
  },
  {
    x: 13.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8,
    y: 8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 13.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 13.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 7.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 6.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 13,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.8,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11,
    y: 11,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 12.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 13,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 12,
    group: 'A'
  },
  {
    x: 9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 12,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 11,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 6.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 13,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 8.7,
    y: 12.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11,
    y: 7.4,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 7.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 7.2,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.9,
    group: 'A'
  },
  {
    x: 10,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 6.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.2,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 6.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.6,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 13.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 12.5,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 13,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 7.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 12.8,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 6.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 13.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 6.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.9,
    group: 'A'
  },
  {
    x: 7.8,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 13,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 12.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 7.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 13.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.5,
    group: 'A'
  },
  {
    x: 12,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.9,
    y: 13,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 6.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.9,
    group: 'A'
  },
  {
    x: 6.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 7.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.9,
    group: 'A'
  },
  {
    x: 12.7,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.1,
    y: 11.2,
    group: 'A'
  },
  {
    x: 12,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.2,
    y: 11,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 13,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10,
    group: 'A'
  },
  {
    x: 7.3,
    y: 12.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11,
    group: 'A'
  },
  {
    x: 12.1,
    y: 12.3,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 12.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 6.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 6.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 12,
    group: 'A'
  },
  {
    x: 6.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 12,
    y: 8,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10,
    y: 8.3,
    group: 'A'
  },
  {
    x: 6.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12.8,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 5.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 12.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 13.1,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 13.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 13.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 7.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.2,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 11,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 7.8,
    y: 11,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12,
    y: 9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 13,
    group: 'A'
  },
  {
    x: 7.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 12,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.8,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.4,
    group: 'A'
  },
  {
    x: 12,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10,
    y: 9,
    group: 'A'
  },
  {
    x: 10,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.4,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.1,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 13.1,
    y: 6.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 6.4,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.7,
    group: 'A'
  },
  {
    x: 12,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 12.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.4,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.5,
    group: 'A'
  },
  {
    x: 6.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 12.2,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 12.5,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 13.4,
    y: 8.2,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.3,
    group: 'A'
  },
  {
    x: 6.7,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 12,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.7,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 12,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.1,
    group: 'A'
  },
  {
    x: 7.7,
    y: 12.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.5,
    y: 13.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.2,
    y: 11.3,
    group: 'A'
  },
  {
    x: 11.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.2,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8,
    group: 'A'
  },
  {
    x: 7.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 12.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12.2,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.3,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10,
    group: 'A'
  },
  {
    x: 7.1,
    y: 12,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 13.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 7.9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 9.1,
    group: 'A'
  },
  {
    x: 12.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.5,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.1,
    group: 'A'
  },
  {
    x: 8.2,
    y: 12.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'A'
  },
  {
    x: 12.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 11.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 7,
    group: 'A'
  },
  {
    x: 9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.5,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 13.1,
    y: 10.3,
    group: 'A'
  },
  {
    x: 12.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 12,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.3,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'A'
  },
  {
    x: 7.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10,
    y: 11.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11,
    y: 10.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.2,
    group: 'A'
  },
  {
    x: 12.7,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.1,
    y: 8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.2,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11,
    group: 'A'
  },
  {
    x: 7.7,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 11.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.9,
    group: 'A'
  },
  {
    x: 11,
    y: 9.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.3,
    group: 'A'
  },
  {
    x: 7.1,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.6,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.7,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 11.1,
    y: 8,
    group: 'A'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 11.8,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 12.5,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.1,
    y: 10,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.5,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.1,
    y: 12.7,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.1,
    group: 'A'
  },
  {
    x: 11.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.8,
    group: 'A'
  },
  {
    x: 11.2,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.2,
    group: 'A'
  },
  {
    x: 8.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.8,
    group: 'A'
  },
  {
    x: 10,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10,
    group: 'A'
  },
  {
    x: 11,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10,
    y: 11.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 8.4,
    group: 'A'
  },
  {
    x: 7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9,
    group: 'A'
  },
  {
    x: 12.2,
    y: 10.6,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8,
    group: 'A'
  },
  {
    x: 13.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.2,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.8,
    y: 10,
    group: 'A'
  },
  {
    x: 9,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.1,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.1,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.7,
    y: 7.7,
    group: 'A'
  },
  {
    x: 7.7,
    y: 9.7,
    group: 'A'
  },
  {
    x: 7.9,
    y: 9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.3,
    group: 'A'
  },
  {
    x: 11,
    y: 11.9,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.6,
    group: 'A'
  },
  {
    x: 10.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.3,
    y: 6.6,
    group: 'A'
  },
  {
    x: 9.5,
    y: 7.6,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.5,
    group: 'A'
  },
  {
    x: 12,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.1,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 11.7,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10,
    group: 'A'
  },
  {
    x: 11.5,
    y: 8.5,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 10.1,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 8.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.5,
    y: 11.6,
    group: 'A'
  },
  {
    x: 9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.1,
    y: 7.6,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'A'
  },
  {
    x: 12.6,
    y: 9.3,
    group: 'A'
  },
  {
    x: 8.2,
    y: 9.5,
    group: 'A'
  },
  {
    x: 10.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 12.1,
    y: 10.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 8.9,
    group: 'A'
  },
  {
    x: 7.1,
    y: 8.3,
    group: 'A'
  },
  {
    x: 7.9,
    y: 7.9,
    group: 'A'
  },
  {
    x: 10.9,
    y: 7.3,
    group: 'A'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'A'
  },
  {
    x: 10.7,
    y: 11.6,
    group: 'A'
  },
  {
    x: 8.8,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10,
    group: 'A'
  },
  {
    x: 8,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'A'
  },
  {
    x: 7.3,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.1,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.8,
    y: 7.1,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.5,
    group: 'A'
  },
  {
    x: 7.5,
    y: 9,
    group: 'A'
  },
  {
    x: 13,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 9,
    group: 'A'
  },
  {
    x: 10.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10,
    y: 9.6,
    group: 'A'
  },
  {
    x: 8.9,
    y: 11.2,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.9,
    y: 8,
    group: 'A'
  },
  {
    x: 8.6,
    y: 10.5,
    group: 'A'
  },
  {
    x: 8.4,
    y: 11.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.5,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.2,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 11,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.4,
    y: 7.7,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.3,
    group: 'A'
  },
  {
    x: 9.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11.6,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.6,
    group: 'A'
  },
  {
    x: 13,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 8.6,
    y: 9.8,
    group: 'A'
  },
  {
    x: 8.7,
    y: 10.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 11.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 12.3,
    group: 'A'
  },
  {
    x: 8.8,
    y: 11.3,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.2,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.6,
    y: 11,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9.2,
    group: 'A'
  },
  {
    x: 9.6,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.7,
    group: 'A'
  },
  {
    x: 12,
    y: 8.1,
    group: 'A'
  },
  {
    x: 11.6,
    y: 10.9,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.2,
    y: 11,
    group: 'A'
  },
  {
    x: 8.5,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.9,
    y: 9.8,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 10,
    y: 10.3,
    group: 'A'
  },
  {
    x: 11,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.4,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10.8,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.1,
    group: 'A'
  },
  {
    x: 8.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 12.7,
    group: 'A'
  },
  {
    x: 11.3,
    y: 11,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10,
    y: 10,
    group: 'A'
  },
  {
    x: 10.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 12.5,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10,
    y: 9.4,
    group: 'A'
  },
  {
    x: 11.9,
    y: 11.7,
    group: 'A'
  },
  {
    x: 10,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.7,
    group: 'A'
  },
  {
    x: 11.1,
    y: 7.9,
    group: 'A'
  },
  {
    x: 11.5,
    y: 12,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 10.3,
    group: 'A'
  },
  {
    x: 8.3,
    y: 7.9,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.2,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9,
    y: 7.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 10.1,
    group: 'A'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.3,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.5,
    group: 'A'
  },
  {
    x: 11.8,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11,
    y: 9.9,
    group: 'A'
  },
  {
    x: 10.2,
    y: 8.4,
    group: 'A'
  },
  {
    x: 10.5,
    y: 7.7,
    group: 'A'
  },
  {
    x: 12,
    y: 9.9,
    group: 'A'
  },
  {
    x: 12.3,
    y: 11.9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 10.2,
    group: 'A'
  },
  {
    x: 12.3,
    y: 9.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'A'
  },
  {
    x: 7.6,
    y: 8.8,
    group: 'A'
  },
  {
    x: 9.2,
    y: 12.3,
    group: 'A'
  },
  {
    x: 11,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.7,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 9.3,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 12.4,
    group: 'A'
  },
  {
    x: 8.5,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.9,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 9.2,
    y: 8.5,
    group: 'A'
  },
  {
    x: 10.7,
    y: 9.5,
    group: 'A'
  },
  {
    x: 11.4,
    y: 8.7,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11.7,
    y: 9.6,
    group: 'A'
  },
  {
    x: 9.8,
    y: 7.6,
    group: 'A'
  },
  {
    x: 10.4,
    y: 11.2,
    group: 'A'
  },
  {
    x: 9.8,
    y: 10.4,
    group: 'A'
  },
  {
    x: 11.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 11.5,
    y: 10.9,
    group: 'A'
  },
  {
    x: 8.8,
    y: 10.6,
    group: 'A'
  },
  {
    x: 10.9,
    y: 8.8,
    group: 'A'
  },
  {
    x: 8.4,
    y: 8.3,
    group: 'A'
  },
  {
    x: 10.3,
    y: 9.6,
    group: 'A'
  },
  {
    x: 11.2,
    y: 10,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.6,
    group: 'A'
  },
  {
    x: 10.8,
    y: 8.9,
    group: 'A'
  },
  {
    x: 9.8,
    y: 9,
    group: 'A'
  },
  {
    x: 10.7,
    y: 8.6,
    group: 'A'
  },
  {
    x: 10.5,
    y: 8.4,
    group: 'A'
  },
  {
    x: 8.3,
    y: 8.9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 8.6,
    group: 'A'
  },
  {
    x: 9.9,
    y: 10.7,
    group: 'A'
  },
  {
    x: 9.9,
    y: 11.5,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.3,
    group: 'A'
  },
  {
    x: 9,
    y: 8.1,
    group: 'A'
  },
  {
    x: 9.5,
    y: 11.3,
    group: 'A'
  },
  {
    x: 8.9,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.4,
    group: 'A'
  },
  {
    x: 10.9,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8.4,
    y: 9.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 9.7,
    group: 'A'
  },
  {
    x: 9.4,
    y: 10.8,
    group: 'A'
  },
  {
    x: 10.2,
    y: 10.9,
    group: 'A'
  },
  {
    x: 11.1,
    y: 11.4,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11.2,
    group: 'A'
  },
  {
    x: 11.1,
    y: 9.2,
    group: 'A'
  },
  {
    x: 10.8,
    y: 9.9,
    group: 'A'
  },
  {
    x: 8,
    y: 13,
    group: 'A'
  },
  {
    x: 10.6,
    y: 10.1,
    group: 'A'
  },
  {
    x: 11,
    y: 9,
    group: 'A'
  },
  {
    x: 8.2,
    y: 10.1,
    group: 'A'
  },
  {
    x: 9.7,
    y: 11,
    group: 'A'
  },
  {
    x: 10.4,
    y: 9.9,
    group: 'A'
  },
  {
    x: 9.7,
    y: 10.6,
    group: 'A'
  },
  {
    x: 7.6,
    y: 7.9,
    group: 'A'
  },
  {
    x: 9.9,
    y: 9.4,
    group: 'A'
  },
  {
    x: 10.4,
    y: 10.2,
    group: 'A'
  },
  {
    x: 9.7,
    y: 8.1,
    group: 'A'
  },
  {
    x: 13.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 11.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 11.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 17.1,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15,
    y: 11.2,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 17,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17,
    group: 'B'
  },
  {
    x: 17.9,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 16,
    y: 16,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 11.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 10.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 11.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 11.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16,
    y: 11.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 16,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 11.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.7,
    y: 17.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 18.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.3,
    y: 17,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 11.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 18,
    group: 'B'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 17.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 12,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 11.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 16,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 16.5,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 11,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 17,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 11.5,
    group: 'B'
  },
  {
    x: 16,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 12,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 17.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 16,
    y: 16,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 11.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13,
    group: 'B'
  },
  {
    x: 17,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13,
    y: 12.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.7,
    y: 17.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 11,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 17.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 11.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 12,
    y: 15,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 11.4,
    y: 13,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 11.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 17,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 11.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 17.3,
    y: 10.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16,
    y: 12,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14,
    group: 'B'
  },
  {
    x: 11.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 18.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 18,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 17.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 11.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 11.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 12.3,
    y: 17.7,
    group: 'B'
  },
  {
    x: 17.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 18.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12,
    y: 15,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13,
    group: 'B'
  },
  {
    x: 11.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.6,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 11.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 10.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 10.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 11.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 18.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 16.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12,
    y: 12,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 11.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 11.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 10.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13,
    group: 'B'
  },
  {
    x: 12,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 11.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 18.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 10.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13,
    group: 'B'
  },
  {
    x: 13,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 11.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 17,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 11.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.7,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 18.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 17.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 11.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13,
    y: 17.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 12,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 11.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 11.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 17,
    y: 11.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 18.5,
    group: 'B'
  },
  {
    x: 13,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 17.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 18.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 11.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 17,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 12.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12,
    group: 'B'
  },
  {
    x: 16,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 17,
    y: 18.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 11.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 9.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 17.6,
    y: 18.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 18.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 17.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17.6,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.4,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13,
    y: 17.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 17.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 18.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 16,
    y: 11.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.2,
    y: 11.4,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 11.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 11.4,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 11.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 11.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 11.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 12,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 17.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 10.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 18.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 12,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 11.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15,
    y: 12.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 18.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 17.3,
    y: 17,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 10.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 17.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 11.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17.2,
    y: 11.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16,
    group: 'B'
  },
  {
    x: 12,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 12,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.3,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 17.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 17.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 18.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 18,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 16,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 17,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 11.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13,
    group: 'B'
  },
  {
    x: 16,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 18,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 17.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 17.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 17.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 17,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13,
    group: 'B'
  },
  {
    x: 16.6,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 10.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 11.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 17,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 9.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 17,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 10.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 11.5,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 11.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17,
    group: 'B'
  },
  {
    x: 15,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 16,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12,
    y: 13.5,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 17.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 11.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 17.8,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 11.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16.9,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 18.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 11.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 17,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 18,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 17,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 17.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 11.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 11.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 17,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12,
    group: 'B'
  },
  {
    x: 13.1,
    y: 18.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.6,
    y: 16,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 17,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 17.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 18.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12,
    y: 17.4,
    group: 'B'
  },
  {
    x: 17.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 11.4,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 11.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 17.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 17,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 11.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 11.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12,
    y: 13.2,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 17,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 18,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 18.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 11.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 16,
    group: 'B'
  },
  {
    x: 12.4,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 18.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 10.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 13.5,
    group: 'B'
  },
  {
    x: 18.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 17,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 16,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 17.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 18.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 18.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16,
    group: 'B'
  },
  {
    x: 12,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 12,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 18.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 17.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 11.4,
    y: 11.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16,
    y: 15,
    group: 'B'
  },
  {
    x: 11.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 18.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 18,
    y: 15,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 17,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 11.9,
    group: 'B'
  },
  {
    x: 17.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 12.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 15.4,
    y: 11.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 17.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 11.1,
    y: 16,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 18,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 9.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 11.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.2,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 11.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 18.4,
    y: 13,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 18.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16,
    y: 12.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 17.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 18.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.3,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.1,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.9,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 11.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 10.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 18.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 11.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 17,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15,
    group: 'B'
  },
  {
    x: 12.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 18.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 11,
    y: 14,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12,
    group: 'B'
  },
  {
    x: 16,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 9.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 10.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 12.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14,
    group: 'B'
  },
  {
    x: 17.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12,
    group: 'B'
  },
  {
    x: 12,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 10.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 11.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12,
    y: 13,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 17.1,
    y: 11,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 11.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 11.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 17.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 11.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 11.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 18.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 17,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 18.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 16,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 12,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 10.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 11.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 18.2,
    y: 17.4,
    group: 'B'
  },
  {
    x: 16,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 12.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 10.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 18.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 11.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 11.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 18.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 18.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 17.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 17,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 17,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12,
    group: 'B'
  },
  {
    x: 17,
    y: 17.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14,
    y: 16.8,
    group: 'B'
  },
  {
    x: 11.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 11.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 17.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 11.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13,
    group: 'B'
  },
  {
    x: 11.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 18.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 12,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 11.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 17,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 11,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 10.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 11.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 17,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 11.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 18.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 18.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 11.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 12,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 17.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 10.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 17.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 11.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 18.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 18.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 17,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 16.3,
    group: 'B'
  },
  {
    x: 10.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 17.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 17,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 18,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 11.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 11.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 16.7,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 17,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 17,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 12.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 11.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 17.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 11.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 18.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17.9,
    y: 14,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 17.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 11.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.9,
    y: 10.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.1,
    y: 16,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13,
    group: 'B'
  },
  {
    x: 17.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 17.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13,
    group: 'B'
  },
  {
    x: 16,
    y: 13,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 17,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 18,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 18.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 11.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 16,
    y: 14,
    group: 'B'
  },
  {
    x: 16,
    y: 15,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.7,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.9,
    group: 'B'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17.6,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.7,
    y: 13,
    group: 'B'
  },
  {
    x: 12,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 18.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 11.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 17.2,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 17.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 17.2,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 17.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16,
    group: 'B'
  },
  {
    x: 11.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 10.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15,
    group: 'B'
  },
  {
    x: 18.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13,
    group: 'B'
  },
  {
    x: 17.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 11.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 18.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 17.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 11.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 11.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 11.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 10.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 17.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 17.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 17,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 10.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 17,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 17.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 11.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13,
    y: 16.3,
    group: 'B'
  },
  {
    x: 18.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 11.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 11.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 16,
    group: 'B'
  },
  {
    x: 16,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 17.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 11.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 18.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 11.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 11.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 11.9,
    y: 12,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 11.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 11.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 17,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14,
    group: 'B'
  },
  {
    x: 18,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 18.1,
    group: 'B'
  },
  {
    x: 17,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 12,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 16,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17,
    y: 12.9,
    group: 'B'
  },
  {
    x: 11.2,
    y: 17.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 11.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 12.2,
    y: 17.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13,
    y: 16.8,
    group: 'B'
  },
  {
    x: 17.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.4,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 16.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16,
    y: 15,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 18.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 17,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 11.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 13,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 11.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 18,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 18,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 17,
    y: 16,
    group: 'B'
  },
  {
    x: 18,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 11.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15.3,
    y: 11.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 11.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 18.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13,
    y: 16,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 19,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 17.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 11.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 17.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 18,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 11.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 17.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 11.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 17,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 10.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 11.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 10.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 17.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.3,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 11.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 11.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 11.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 11.4,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 17.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 17.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 11.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13,
    y: 16,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 11,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 16.1,
    group: 'B'
  },
  {
    x: 17.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 18.1,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 17.5,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 12,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 17.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 18.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 16,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 10.7,
    group: 'B'
  },
  {
    x: 10.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 17,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 10.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 17.5,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.7,
    y: 17,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 18,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 18.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 11.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 17.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 16.9,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14,
    y: 19,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14,
    y: 16.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 16,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 11.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 10.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 17,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15,
    group: 'B'
  },
  {
    x: 9.5,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 18.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 11.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15,
    group: 'B'
  },
  {
    x: 16,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14,
    y: 16,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 11.4,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 17.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 11.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12,
    group: 'B'
  },
  {
    x: 13.5,
    y: 9.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 18.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13,
    y: 16,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 10.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.3,
    group: 'B'
  },
  {
    x: 17,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13,
    group: 'B'
  },
  {
    x: 17.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 11.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 10.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 17,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 18,
    group: 'B'
  },
  {
    x: 13,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 18,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 11.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 17,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 17.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14,
    group: 'B'
  },
  {
    x: 16,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 11.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 17.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 17.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 18.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 17.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 11.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 18.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 11.8,
    group: 'B'
  },
  {
    x: 12,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 18.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 18.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.1,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 19.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 11.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 18,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 17.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 11.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 17.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.9,
    group: 'B'
  },
  {
    x: 17.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.2,
    group: 'B'
  },
  {
    x: 17,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17,
    group: 'B'
  },
  {
    x: 14,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 11.8,
    y: 17.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.9,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11,
    y: 15.5,
    group: 'B'
  },
  {
    x: 18.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 17.8,
    group: 'B'
  },
  {
    x: 18.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.5,
    y: 16,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 11.4,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.7,
    y: 16.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 11.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 17,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 17,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 11.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 18.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 10.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 17,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 11.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 16,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14,
    y: 13,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13,
    y: 13,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 17,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.2,
    group: 'B'
  },
  {
    x: 11.9,
    y: 16.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 12,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 17,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15.5,
    group: 'B'
  },
  {
    x: 17.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13,
    group: 'B'
  },
  {
    x: 14,
    y: 16,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 18,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 11.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 17,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 10.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 11.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 11.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16,
    y: 13,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 11.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 11.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 16.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 16,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.8,
    group: 'B'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 17,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 11.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 17,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 17,
    y: 17.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 11.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 17,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 10.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.2,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 11.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13,
    group: 'B'
  },
  {
    x: 16.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 17,
    y: 15,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 11.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 10.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 17.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 17.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 15.1,
    y: 11.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 10.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 11.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.1,
    group: 'B'
  },
  {
    x: 11.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 17.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15,
    group: 'B'
  },
  {
    x: 11.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.3,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 11.8,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 18.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13,
    group: 'B'
  },
  {
    x: 13.6,
    y: 17.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 13,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 17.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 11.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 17.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.5,
    y: 13,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 17,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 17.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 17.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 17,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.6,
    group: 'B'
  },
  {
    x: 15,
    y: 10.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 17,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 17,
    y: 13,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.6,
    y: 17.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 18.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 17.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 17,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 10.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 17,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13,
    group: 'B'
  },
  {
    x: 17.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 11.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 18.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 17.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 11.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 17.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 17.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 16,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 11.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 17.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 11.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 17.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 11.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15,
    y: 14,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.9,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 11.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.3,
    group: 'B'
  },
  {
    x: 11.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17,
    y: 13,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11.3,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 11.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14,
    group: 'B'
  },
  {
    x: 16,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 11.6,
    group: 'B'
  },
  {
    x: 11.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14,
    y: 17.3,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 17,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12,
    group: 'B'
  },
  {
    x: 16.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 16,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.3,
    y: 18.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.4,
    y: 12.8,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 18.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 11.7,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.4,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 17.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12,
    y: 11.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.8,
    group: 'B'
  },
  {
    x: 15,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.7,
    y: 11,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 11.6,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15.9,
    y: 10.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16,
    y: 11,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 17.6,
    y: 16.7,
    group: 'B'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 16,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 17.1,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 17.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 17.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15,
    y: 16,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.8,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 17.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 17.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 11.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.5,
    group: 'B'
  },
  {
    x: 17.4,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 16,
    y: 14,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.5,
    group: 'B'
  },
  {
    x: 11.4,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13,
    y: 11.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 17.1,
    y: 15,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 12.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.9,
    group: 'B'
  },
  {
    x: 17.2,
    y: 13,
    group: 'B'
  },
  {
    x: 17,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 17.3,
    y: 17.2,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14,
    group: 'B'
  },
  {
    x: 12.7,
    y: 17.1,
    group: 'B'
  },
  {
    x: 14,
    y: 13.2,
    group: 'B'
  },
  {
    x: 13.2,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 11.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 16.5,
    y: 13,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 12.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.3,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.7,
    group: 'B'
  },
  {
    x: 17.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.7,
    y: 11.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.5,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 17.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 14.2,
    y: 17.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 12.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 16.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.2,
    y: 16,
    group: 'B'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.1,
    group: 'B'
  },
  {
    x: 14,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16,
    y: 15.4,
    group: 'B'
  },
  {
    x: 11.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 18.4,
    y: 13,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.1,
    y: 16.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.1,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15,
    group: 'B'
  },
  {
    x: 17.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 17.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 11.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.8,
    y: 11.5,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17.1,
    y: 13,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 13,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 17.4,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 11.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 16.4,
    group: 'B'
  },
  {
    x: 17.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 17,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 11,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 16.5,
    y: 17.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 16.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 11.6,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15,
    group: 'B'
  },
  {
    x: 15.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.8,
    y: 16.4,
    group: 'B'
  },
  {
    x: 15,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.6,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.5,
    y: 15,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 18.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14,
    group: 'B'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.3,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.1,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.6,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 12.8,
    group: 'B'
  },
  {
    x: 11.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.8,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.3,
    group: 'B'
  },
  {
    x: 12.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 11.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 12.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 12.8,
    y: 15.6,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14,
    group: 'B'
  },
  {
    x: 14.1,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.7,
    group: 'B'
  },
  {
    x: 11.9,
    y: 11.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 12.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.5,
    y: 17.8,
    group: 'B'
  },
  {
    x: 15,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13.2,
    y: 12.6,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 16,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.9,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 12.7,
    y: 17,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 16.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.9,
    group: 'B'
  },
  {
    x: 12.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 16.2,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 16.8,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.6,
    y: 12.8,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 17,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.8,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 12.3,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'B'
  },
  {
    x: 16.4,
    y: 11.2,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15,
    group: 'B'
  },
  {
    x: 12.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 12.2,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 12.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12,
    y: 15.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 19.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 16.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 12.7,
    y: 12.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 12.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 13.6,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.1,
    y: 12.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.4,
    y: 12.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 13,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.1,
    y: 15,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 18,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.3,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13.9,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.2,
    y: 15,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.7,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.7,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.6,
    group: 'B'
  },
  {
    x: 16.5,
    y: 14,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 11.9,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.8,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.6,
    group: 'B'
  },
  {
    x: 12.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.6,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16.4,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 12.7,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.2,
    group: 'B'
  },
  {
    x: 12.8,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.9,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16,
    y: 15.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 16,
    y: 12.7,
    group: 'B'
  },
  {
    x: 16,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.6,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.8,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.2,
    y: 13,
    group: 'B'
  },
  {
    x: 15,
    y: 13.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.4,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.4,
    y: 14.1,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.2,
    group: 'B'
  },
  {
    x: 15.9,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13,
    group: 'B'
  },
  {
    x: 14.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 16.3,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.1,
    group: 'B'
  },
  {
    x: 12,
    y: 17,
    group: 'B'
  },
  {
    x: 16.4,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.2,
    group: 'B'
  },
  {
    x: 15.8,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15,
    group: 'B'
  },
  {
    x: 15,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 17.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.4,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.4,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14.7,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15,
    y: 12.9,
    group: 'B'
  },
  {
    x: 10.6,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.8,
    y: 15.2,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.8,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.2,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.8,
    y: 15.1,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.1,
    group: 'B'
  },
  {
    x: 16.3,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.8,
    y: 15,
    group: 'B'
  },
  {
    x: 14.6,
    y: 13,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.9,
    y: 12.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 14.4,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.7,
    group: 'B'
  },
  {
    x: 15.5,
    y: 15,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 16.1,
    y: 15.4,
    group: 'B'
  },
  {
    x: 15.1,
    y: 16,
    group: 'B'
  },
  {
    x: 14.2,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 15.4,
    y: 13.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 12.3,
    group: 'B'
  },
  {
    x: 13.2,
    y: 14,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.2,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 11.7,
    group: 'B'
  },
  {
    x: 15.9,
    y: 12.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 12,
    y: 13.8,
    group: 'B'
  },
  {
    x: 13.9,
    y: 16,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14,
    group: 'B'
  },
  {
    x: 14.8,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13.1,
    y: 17.1,
    group: 'B'
  },
  {
    x: 13.3,
    y: 15.2,
    group: 'B'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.7,
    y: 17.2,
    group: 'B'
  },
  {
    x: 16.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 12.7,
    group: 'B'
  },
  {
    x: 14,
    y: 13.7,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.3,
    y: 14,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.6,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 13,
    y: 14.1,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.6,
    group: 'B'
  },
  {
    x: 15.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.1,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.5,
    group: 'B'
  },
  {
    x: 16,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15.1,
    group: 'B'
  },
  {
    x: 18.5,
    y: 15.5,
    group: 'B'
  },
  {
    x: 16,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.5,
    y: 12.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 15.7,
    group: 'B'
  },
  {
    x: 16.5,
    y: 15.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.3,
    group: 'B'
  },
  {
    x: 13.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 15.6,
    y: 16.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 14.2,
    group: 'B'
  },
  {
    x: 17.5,
    y: 13.8,
    group: 'B'
  },
  {
    x: 17.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 14.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.7,
    group: 'B'
  },
  {
    x: 13.8,
    y: 11.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 14,
    group: 'B'
  },
  {
    x: 13,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.5,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.4,
    group: 'B'
  },
  {
    x: 16,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.2,
    y: 14.3,
    group: 'B'
  },
  {
    x: 12.7,
    y: 13.1,
    group: 'B'
  },
  {
    x: 13.9,
    y: 13.9,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.2,
    group: 'B'
  },
  {
    x: 14.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.7,
    y: 15.3,
    group: 'B'
  },
  {
    x: 15.7,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15,
    group: 'B'
  },
  {
    x: 14.7,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.9,
    y: 16,
    group: 'B'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.2,
    y: 13.7,
    group: 'B'
  },
  {
    x: 17,
    y: 15.2,
    group: 'B'
  },
  {
    x: 14,
    y: 11.8,
    group: 'B'
  },
  {
    x: 13,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.3,
    y: 15.6,
    group: 'B'
  },
  {
    x: 11.3,
    y: 15.7,
    group: 'B'
  },
  {
    x: 14,
    y: 15.9,
    group: 'B'
  },
  {
    x: 12.3,
    y: 16.1,
    group: 'B'
  },
  {
    x: 15,
    y: 15.8,
    group: 'B'
  },
  {
    x: 15.9,
    y: 13.8,
    group: 'B'
  },
  {
    x: 12.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 15.6,
    y: 13,
    group: 'B'
  },
  {
    x: 15.3,
    y: 14.4,
    group: 'B'
  },
  {
    x: 14.8,
    y: 14,
    group: 'B'
  },
  {
    x: 14.7,
    y: 16.1,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15,
    group: 'B'
  },
  {
    x: 15.8,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.5,
    y: 15.1,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.9,
    group: 'B'
  },
  {
    x: 16.2,
    y: 12.7,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.7,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.6,
    group: 'B'
  },
  {
    x: 14.4,
    y: 15,
    group: 'B'
  },
  {
    x: 13,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 14.6,
    y: 14.5,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 17.1,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14,
    y: 15.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 17.3,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 13.7,
    y: 14.8,
    group: 'B'
  },
  {
    x: 13.7,
    y: 15.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'B'
  },
  {
    x: 15,
    y: 14.7,
    group: 'B'
  },
  {
    x: 13.4,
    y: 16.7,
    group: 'B'
  },
  {
    x: 15.4,
    y: 15.3,
    group: 'B'
  },
  {
    x: 12.5,
    y: 16.1,
    group: 'B'
  },
  {
    x: 14.9,
    y: 14.3,
    group: 'B'
  },
  {
    x: 13.9,
    y: 14.2,
    group: 'B'
  },
  {
    x: 15.1,
    y: 14.9,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'B'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.4,
    y: 13.3,
    group: 'B'
  },
  {
    x: 16.1,
    y: 14.3,
    group: 'B'
  },
  {
    x: 16.4,
    y: 13.2,
    group: 'B'
  },
  {
    x: 16.7,
    y: 16.5,
    group: 'B'
  },
  {
    x: 14,
    y: 14.4,
    group: 'B'
  },
  {
    x: 12.9,
    y: 13.5,
    group: 'B'
  },
  {
    x: 12.6,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14,
    y: 14.8,
    group: 'B'
  },
  {
    x: 14.5,
    y: 13.5,
    group: 'B'
  },
  {
    x: 13,
    y: 14.7,
    group: 'B'
  },
  {
    x: 18.1,
    y: 15.1,
    group: 'B'
  },
  {
    x: 12,
    y: 15.3,
    group: 'B'
  },
  {
    x: 14.3,
    y: 15.4,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14,
    group: 'B'
  },
  {
    x: 15.9,
    y: 15.5,
    group: 'B'
  },
  {
    x: 13.5,
    y: 14.5,
    group: 'B'
  },
  {
    x: 12.4,
    y: 15.6,
    group: 'B'
  },
  {
    x: 14.1,
    y: 15.9,
    group: 'B'
  },
  {
    x: 15.3,
    y: 11.9,
    group: 'B'
  },
  {
    x: 13.8,
    y: 14.5,
    group: 'B'
  },
  {
    x: 13.3,
    y: 14.2,
    group: 'B'
  },
  {
    x: 13.1,
    y: 13.6,
    group: 'B'
  },
  {
    x: 15.7,
    y: 14.1,
    group: 'B'
  },
  {
    x: 14.5,
    y: 14.6,
    group: 'B'
  },
  {
    x: 12.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 12.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 13.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 13.5,
    y: 16,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 11.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 10.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 11.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 5.7,
    y: 19,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14,
    group: 'C'
  },
  {
    x: 12.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 11.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16,
    group: 'C'
  },
  {
    x: 7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 19.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 19,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14,
    group: 'C'
  },
  {
    x: 5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 5.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 11.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 5.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 5.9,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 11.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 13.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 11.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 14.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 13.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 5.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 19.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 11.9,
    group: 'C'
  },
  {
    x: 11,
    y: 15,
    group: 'C'
  },
  {
    x: 6.5,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 19.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13,
    group: 'C'
  },
  {
    x: 7.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 19.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 11.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.7,
    group: 'C'
  },
  {
    x: 13.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 13.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 18.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 13.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17,
    group: 'C'
  },
  {
    x: 11.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 6.7,
    y: 19.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 19,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 11.9,
    group: 'C'
  },
  {
    x: 5.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 19.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.6,
    y: 11.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 5.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18,
    group: 'C'
  },
  {
    x: 11.1,
    y: 11.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 5.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 14.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 10.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16,
    group: 'C'
  },
  {
    x: 11,
    y: 17,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 11.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 12.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 11.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 5.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.8,
    y: 12,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 11.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 5.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 11.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15,
    group: 'C'
  },
  {
    x: 12,
    y: 12.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 20,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.5,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7,
    y: 16,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 13.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 13.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 17,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 19.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 13.9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 17,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 5.9,
    y: 18,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 4.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 13.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 11.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 19.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14,
    group: 'C'
  },
  {
    x: 8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 13.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12,
    y: 16,
    group: 'C'
  },
  {
    x: 7.8,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18,
    group: 'C'
  },
  {
    x: 10,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 6.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 11,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 11,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 19.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 19,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 13.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7,
    y: 18.8,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.5,
    y: 11.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11,
    y: 13,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 19.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 11.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 5.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10,
    y: 13,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 5.7,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 20.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.9,
    y: 11.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 5.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 12.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12,
    y: 13,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 18,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 11.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 12.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 11.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 5.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 18.7,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 12.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 6.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 12.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 18,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 12,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 11.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 5.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 13.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 5.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 19.2,
    group: 'C'
  },
  {
    x: 12.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 13.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 11.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 11,
    y: 13,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10,
    y: 11.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 11.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9,
    y: 17,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18,
    group: 'C'
  },
  {
    x: 12.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 13,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 5.9,
    y: 20.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 12.4,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 18,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 19.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 12.9,
    y: 20.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 19.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 19,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 6.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 13,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 13.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 20.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12,
    y: 19.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 11.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 5.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 20.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 7.6,
    y: 19,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 19.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 5.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 19,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.4,
    group: 'C'
  },
  {
    x: 11,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 19.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 11.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 4.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 11.7,
    group: 'C'
  },
  {
    x: 10,
    y: 19.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18.4,
    group: 'C'
  },
  {
    x: 5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 6.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 18,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 5.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 5.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10,
    y: 18,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 11.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 12.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 19.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 12.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 13,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 11,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 11.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 19.3,
    group: 'C'
  },
  {
    x: 9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 19.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 12.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 11.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 11.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 5.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 12,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 7.3,
    y: 18,
    group: 'C'
  },
  {
    x: 11.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 5.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17,
    group: 'C'
  },
  {
    x: 8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 20.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13,
    group: 'C'
  },
  {
    x: 6.2,
    y: 19.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 12,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 13.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 12.7,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14,
    group: 'C'
  },
  {
    x: 13.1,
    y: 15,
    group: 'C'
  },
  {
    x: 6.9,
    y: 11.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 13.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 5.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 20.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 12.1,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 19.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 13,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18,
    group: 'C'
  },
  {
    x: 7,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 13,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17,
    group: 'C'
  },
  {
    x: 7.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 13.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 13.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 19,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 5.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 14.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 18.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 12.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 19,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 11.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 13.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 5.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 10.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 5.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 11.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11.7,
    y: 19.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 11.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7,
    y: 12.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 5.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 13.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 14,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14,
    group: 'C'
  },
  {
    x: 12,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.3,
    y: 19.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 5.7,
    y: 20,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 18.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 11.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 19.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 13.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 6.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 13.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 19,
    group: 'C'
  },
  {
    x: 10.8,
    y: 19.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 6.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 14.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18,
    group: 'C'
  },
  {
    x: 11,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 12,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 19,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 12,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6,
    y: 14,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 19.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 13.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 19.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 12.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 19.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 19.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 5.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18.9,
    group: 'C'
  },
  {
    x: 6.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 11.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13,
    y: 17,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 5.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 19.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 12.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 14.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 10.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 11.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 13,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 7,
    y: 16,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 5.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 12,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 5.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 19,
    group: 'C'
  },
  {
    x: 7.4,
    y: 19.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12,
    group: 'C'
  },
  {
    x: 6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 5.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 19.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 20.1,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 13.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 4.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.2,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12,
    y: 13.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 19.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 11.8,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 19.4,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 6.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 11.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 13,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 19,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 5.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 13.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 5.3,
    y: 11.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 11.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 13.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 19,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 19.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8,
    y: 13,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 5.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17,
    group: 'C'
  },
  {
    x: 6.5,
    y: 11.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 5.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 11,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 13,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 19.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 12,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 5.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16,
    group: 'C'
  },
  {
    x: 6.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9,
    y: 13,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 13,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 12,
    y: 17,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 13.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 19.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18,
    group: 'C'
  },
  {
    x: 11,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 18,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 13.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 10.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 20.6,
    group: 'C'
  },
  {
    x: 11,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 19.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 11.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 5.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 20.5,
    group: 'C'
  },
  {
    x: 10,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 13.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 14.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 5.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 10.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 11.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 18,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 13.3,
    y: 12.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 11.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 13.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 5.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 19,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 11.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 10.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 5.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 19.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9,
    y: 11.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 13.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 13.3,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 13.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16,
    group: 'C'
  },
  {
    x: 7.8,
    y: 11.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8,
    y: 19.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 5.9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 6.5,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 13.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 19.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 13,
    y: 18.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.5,
    y: 18,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 11.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.6,
    y: 17,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 11.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 16.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 11,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 19.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 4.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 4.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 10.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 11.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 19.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18,
    group: 'C'
  },
  {
    x: 11.8,
    y: 12.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 5.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 13.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 5.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 9.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 11.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9,
    y: 12.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14,
    group: 'C'
  },
  {
    x: 13.3,
    y: 18.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 13,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 5.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 14.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12,
    y: 12.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 12.6,
    y: 18.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 3.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 13.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 13.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16,
    group: 'C'
  },
  {
    x: 12,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 5.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.8,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17,
    group: 'C'
  },
  {
    x: 6.8,
    y: 13,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 13.2,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 5.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 13.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 12.2,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 11,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 6.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 5.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.9,
    group: 'C'
  },
  {
    x: 7,
    y: 13,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 14.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 11.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 19,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 12,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.1,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 11,
    y: 18.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 13,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 18.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 19.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 11.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 11.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 11.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 19.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 11.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 4.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 14.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 18,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18,
    group: 'C'
  },
  {
    x: 11,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.6,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.8,
    y: 13,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 4.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 11.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 19.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 19.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 19,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 19.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 13.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 18,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.3,
    group: 'C'
  },
  {
    x: 5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 13,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 19.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 12.4,
    y: 13,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 11.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 5.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 13.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 19,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 5.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 13.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16,
    group: 'C'
  },
  {
    x: 14.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 5.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 13.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 13.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 12,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17,
    group: 'C'
  },
  {
    x: 11,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14,
    group: 'C'
  },
  {
    x: 7.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 5.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17,
    group: 'C'
  },
  {
    x: 13.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13,
    group: 'C'
  },
  {
    x: 8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 14,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 5.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 12,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6.4,
    y: 15,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11,
    y: 13,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 19.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 19,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 13.3,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 11.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 13.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 5.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.7,
    y: 19,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7,
    y: 17,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 11.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 5.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 18,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 11.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 19.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 13.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 5.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 11.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.4,
    y: 19.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8,
    y: 18,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9,
    y: 19.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 19,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 5.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.6,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 11.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8,
    y: 13,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 19.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 5.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8,
    y: 13,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 10.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 18.2,
    group: 'C'
  },
  {
    x: 13.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 12,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10.9,
    y: 11.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 20.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14,
    group: 'C'
  },
  {
    x: 13.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 4.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 19.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 19.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 11.7,
    group: 'C'
  },
  {
    x: 12.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 5.9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 13.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'C'
  },
  {
    x: 12.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12,
    y: 16,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.5,
    group: 'C'
  },
  {
    x: 12,
    y: 17,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9,
    y: 13,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 5.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 4.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.1,
    y: 18,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 12,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 14.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 5.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 5.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 5.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 19.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18,
    group: 'C'
  },
  {
    x: 6.8,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 13.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14,
    group: 'C'
  },
  {
    x: 11,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 13.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 19.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9,
    y: 19.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 18,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 11.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.3,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 14,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 14.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 10.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 5.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 11.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 13.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15,
    group: 'C'
  },
  {
    x: 12.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 6.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 11.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 5.7,
    y: 19.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 12.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 10.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 19.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 4.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12,
    group: 'C'
  },
  {
    x: 7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 5.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.1,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 11.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 19,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 19.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 5.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 13.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 5.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11,
    y: 18,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.9,
    y: 11.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17,
    group: 'C'
  },
  {
    x: 10,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 5.9,
    y: 16,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 12.2,
    group: 'C'
  },
  {
    x: 12,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 13,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 18,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 11.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 4.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 13.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 11.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 12.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 5.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.9,
    group: 'C'
  },
  {
    x: 13.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 11.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 19.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 12,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 5.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 11.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 5.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 19.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 16.9,
    group: 'C'
  },
  {
    x: 5.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 11.5,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 13.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 11,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 5.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 17,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 19.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 5.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.7,
    y: 10.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 11.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 11.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 5.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 19.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10,
    y: 18,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 13.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 11.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 11.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 13,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 14.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 12.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12.4,
    group: 'C'
  },
  {
    x: 6.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 19.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 17,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.5,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.1,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 20.5,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 13,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.5,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 11.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 13,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 13,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.7,
    y: 13,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 18.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 14.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 20.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 11.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 5.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 11.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 19.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 13,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 19.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 5.8,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 10.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9,
    y: 19,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 5.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 13,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 13,
    y: 19,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 19.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11,
    y: 20.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16,
    group: 'C'
  },
  {
    x: 12,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12,
    group: 'C'
  },
  {
    x: 7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.1,
    group: 'C'
  },
  {
    x: 5.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.1,
    group: 'C'
  },
  {
    x: 8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 11.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 13.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12,
    y: 14.3,
    group: 'C'
  },
  {
    x: 5.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 19.2,
    group: 'C'
  },
  {
    x: 14.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 5.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 5.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 4.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18,
    group: 'C'
  },
  {
    x: 8,
    y: 17,
    group: 'C'
  },
  {
    x: 8,
    y: 12.5,
    group: 'C'
  },
  {
    x: 13.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15,
    group: 'C'
  },
  {
    x: 5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 11.5,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 19.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11,
    y: 20.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.3,
    y: 17,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12,
    y: 15,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 14,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 13.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 19.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 11.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 6.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 19.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 19.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 10.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 19.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 19,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 6.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 19.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 6.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 10.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 11.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 5.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18,
    group: 'C'
  },
  {
    x: 11,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 19.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 19.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 10.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 5.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15,
    group: 'C'
  },
  {
    x: 6.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 4.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 19.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 13,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.5,
    group: 'C'
  },
  {
    x: 12,
    y: 15,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 19.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 14.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 13.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 5.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14,
    group: 'C'
  },
  {
    x: 13.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18.8,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 11.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 12,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11,
    y: 17,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 13.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 13,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14,
    group: 'C'
  },
  {
    x: 5.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 11,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7,
    y: 12.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7,
    y: 15,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 19,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 10.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 19.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 19.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 5.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 19,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 6.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.1,
    y: 14,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 14.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11,
    y: 17,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 11.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 11.3,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.7,
    y: 18,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 12.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 11.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 11.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 20.5,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 13.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 12,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 11.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 11.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 11.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 7.8,
    y: 19.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 5.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 6.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8,
    y: 14,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 19.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 10.9,
    group: 'C'
  },
  {
    x: 11,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.7,
    y: 18,
    group: 'C'
  },
  {
    x: 9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 5.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 11,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 5.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7,
    y: 12.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 10,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 11.9,
    group: 'C'
  },
  {
    x: 12.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 13.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14,
    group: 'C'
  },
  {
    x: 5.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8,
    y: 19.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14,
    group: 'C'
  },
  {
    x: 6.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 4.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.7,
    group: 'C'
  },
  {
    x: 12.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 12,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 12.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 19.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 20.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 5.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 5.5,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 11.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 5.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 13.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 18,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 19,
    group: 'C'
  },
  {
    x: 7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 19,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 14,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 11.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 5.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 13.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 14.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18,
    group: 'C'
  },
  {
    x: 12.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 10.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 11.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 18.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 5.2,
    y: 15,
    group: 'C'
  },
  {
    x: 13.1,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 12,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 11.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 5.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 11.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 11.9,
    group: 'C'
  },
  {
    x: 11,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 5.8,
    y: 12.6,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 12.6,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 12,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 12,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 13.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.5,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 19,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14,
    group: 'C'
  },
  {
    x: 10,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 13.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 11.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 5.7,
    y: 13,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11,
    y: 17,
    group: 'C'
  },
  {
    x: 13.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 5.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 21,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 5.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.9,
    y: 19.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 11.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.7,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16,
    group: 'C'
  },
  {
    x: 13.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 7,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 18,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 5.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 5.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 13.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.3,
    y: 11.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 12.9,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 13.6,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 14,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 19,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 13.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18,
    group: 'C'
  },
  {
    x: 12.3,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 5.6,
    y: 17,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 19,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15,
    group: 'C'
  },
  {
    x: 8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.6,
    y: 19.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 11.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 13,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 4.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 19,
    group: 'C'
  },
  {
    x: 9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 5.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 5.3,
    y: 14,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 19,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.4,
    group: 'C'
  },
  {
    x: 11,
    y: 18.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11,
    y: 10.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 19.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 19.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14,
    group: 'C'
  },
  {
    x: 11,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 5.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13,
    group: 'C'
  },
  {
    x: 12.4,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 19.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 13.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 5.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 12,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.5,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 19,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 14.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11,
    y: 12,
    group: 'C'
  },
  {
    x: 9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12.7,
    y: 18,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 13,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 11.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 11.8,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 20.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 5.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 12,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 12.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 12,
    y: 16,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 20.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 5.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 13.5,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 11.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 18.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 12.3,
    y: 12.9,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 5.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 11.1,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 18.8,
    group: 'C'
  },
  {
    x: 5.8,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 5.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 7.6,
    y: 11.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 5.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 19.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 11,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 18.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13,
    group: 'C'
  },
  {
    x: 7.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 19.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 5.8,
    y: 13,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 18.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6,
    y: 18.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 5.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.8,
    group: 'C'
  },
  {
    x: 12,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 19.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 13.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.7,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 20,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 12.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 19.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 18.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 13.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 11.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17.5,
    group: 'C'
  },
  {
    x: 5.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.1,
    y: 12.1,
    group: 'C'
  },
  {
    x: 7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7,
    y: 15,
    group: 'C'
  },
  {
    x: 7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 13,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 10.2,
    y: 11.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 19.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 12.5,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17,
    group: 'C'
  },
  {
    x: 4.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 18,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 10,
    group: 'C'
  },
  {
    x: 10,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 13.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13,
    group: 'C'
  },
  {
    x: 10,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 18,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.8,
    group: 'C'
  },
  {
    x: 5.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 5.9,
    y: 19,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 12,
    y: 18.1,
    group: 'C'
  },
  {
    x: 5.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12,
    y: 16,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 20.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.5,
    y: 11.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 6.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 19.2,
    group: 'C'
  },
  {
    x: 10,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 13.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 7.4,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 13.7,
    y: 20,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 5.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 19.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13,
    group: 'C'
  },
  {
    x: 9.8,
    y: 19.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 13.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 11.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 13.1,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 12.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 12,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 11,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16,
    group: 'C'
  },
  {
    x: 5.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 13.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 19.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 13,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 13.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 19.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 12.7,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 19,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12,
    y: 17,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 3.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 11,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 4.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 19.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15,
    group: 'C'
  },
  {
    x: 13.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17,
    group: 'C'
  },
  {
    x: 7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 12.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 12,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 5.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 13.6,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 18.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 11.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.2,
    group: 'C'
  },
  {
    x: 14,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9,
    y: 17,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 19.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 10.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 5.5,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17,
    group: 'C'
  },
  {
    x: 7.3,
    y: 12.5,
    group: 'C'
  },
  {
    x: 12,
    y: 12.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 18.2,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10,
    y: 12.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 5.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 19.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7,
    y: 20.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 19,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.8,
    group: 'C'
  },
  {
    x: 13.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 13.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 13,
    y: 12.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 5.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11,
    y: 14,
    group: 'C'
  },
  {
    x: 12,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 4.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 12.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.1,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.3,
    group: 'C'
  },
  {
    x: 13,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 16,
    group: 'C'
  },
  {
    x: 11,
    y: 19,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 19.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 18,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17,
    group: 'C'
  },
  {
    x: 8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 11.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 12,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 17.6,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 13.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.6,
    group: 'C'
  },
  {
    x: 6.5,
    y: 11.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 13.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 13.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 11,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 7.8,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 6.2,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 19,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 19.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.6,
    group: 'C'
  },
  {
    x: 12.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17,
    group: 'C'
  },
  {
    x: 12.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.2,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.8,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.3,
    y: 18,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 11.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13,
    group: 'C'
  },
  {
    x: 8.2,
    y: 18.2,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 13.7,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 11,
    y: 14,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.1,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 5.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.6,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 12,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 20.5,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 19.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 19.1,
    group: 'C'
  },
  {
    x: 9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.6,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10,
    y: 18,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 15.3,
    group: 'C'
  },
  {
    x: 7.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 12.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.9,
    group: 'C'
  },
  {
    x: 12.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.5,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16,
    group: 'C'
  },
  {
    x: 7.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 13,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.8,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10,
    y: 17.6,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 11.4,
    group: 'C'
  },
  {
    x: 8,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9,
    y: 14,
    group: 'C'
  },
  {
    x: 12,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15,
    group: 'C'
  },
  {
    x: 12.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13,
    group: 'C'
  },
  {
    x: 8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 20.9,
    group: 'C'
  },
  {
    x: 13.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 11.8,
    group: 'C'
  },
  {
    x: 9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 7,
    y: 18,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.8,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 19.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.4,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 18.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.4,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 5.8,
    y: 17,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15,
    group: 'C'
  },
  {
    x: 12.6,
    y: 12,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 11.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.2,
    group: 'C'
  },
  {
    x: 6.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.4,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 6.4,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 19.1,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 5.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.5,
    y: 14,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 17.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.9,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12,
    y: 17,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.8,
    group: 'C'
  },
  {
    x: 10,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14,
    group: 'C'
  },
  {
    x: 12.4,
    y: 16,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 7.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 14.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 19.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.7,
    group: 'C'
  },
  {
    x: 12.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 7,
    y: 19.4,
    group: 'C'
  },
  {
    x: 11.8,
    y: 13,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13,
    group: 'C'
  },
  {
    x: 11,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11,
    y: 13,
    group: 'C'
  },
  {
    x: 11,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15,
    group: 'C'
  },
  {
    x: 12.3,
    y: 13,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16,
    group: 'C'
  },
  {
    x: 9,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 12.2,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10,
    y: 13.9,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 5,
    y: 19.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.5,
    y: 18.8,
    group: 'C'
  },
  {
    x: 5.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 10,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 13.5,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.5,
    y: 20.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16,
    group: 'C'
  },
  {
    x: 12,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.8,
    group: 'C'
  },
  {
    x: 7.8,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 12.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11,
    y: 13.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.8,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.7,
    y: 13.4,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 16.7,
    group: 'C'
  },
  {
    x: 7.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12,
    y: 17.2,
    group: 'C'
  },
  {
    x: 11.4,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8,
    y: 13.7,
    group: 'C'
  },
  {
    x: 12.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.6,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.9,
    group: 'C'
  },
  {
    x: 8,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 14.1,
    group: 'C'
  },
  {
    x: 13.5,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.7,
    group: 'C'
  },
  {
    x: 5.5,
    y: 15,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.4,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17,
    group: 'C'
  },
  {
    x: 10.5,
    y: 19,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10,
    y: 12.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 11.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.6,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 7.8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.6,
    group: 'C'
  },
  {
    x: 6.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14,
    group: 'C'
  },
  {
    x: 9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.3,
    y: 16,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 19,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 17,
    group: 'C'
  },
  {
    x: 13.7,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 12.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 16.5,
    group: 'C'
  },
  {
    x: 5.5,
    y: 15,
    group: 'C'
  },
  {
    x: 5.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.3,
    group: 'C'
  },
  {
    x: 6.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 12.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 11.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.6,
    y: 12.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11,
    y: 14.2,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.4,
    group: 'C'
  },
  {
    x: 4.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14,
    group: 'C'
  },
  {
    x: 6.7,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 11.5,
    group: 'C'
  },
  {
    x: 8,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 6.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 12.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 11,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 6.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 6.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.6,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 11.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 18.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 6.9,
    y: 17,
    group: 'C'
  },
  {
    x: 6.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 12.5,
    group: 'C'
  },
  {
    x: 8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 6.8,
    y: 18.7,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.5,
    group: 'C'
  },
  {
    x: 5.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 13.7,
    group: 'C'
  },
  {
    x: 6.5,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 11.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 12.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 12.1,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 6.3,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 18.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.3,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11,
    y: 15.8,
    group: 'C'
  },
  {
    x: 5.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10,
    y: 14,
    group: 'C'
  },
  {
    x: 9.8,
    y: 11.7,
    group: 'C'
  },
  {
    x: 9.4,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.3,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.3,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 17,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.4,
    y: 19,
    group: 'C'
  },
  {
    x: 12,
    y: 18,
    group: 'C'
  },
  {
    x: 10.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 12,
    y: 14.3,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.1,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 11.4,
    y: 14.9,
    group: 'C'
  },
  {
    x: 11,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 17.6,
    group: 'C'
  },
  {
    x: 7.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 12.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.3,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 17.5,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 12,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.6,
    y: 14.6,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 12.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.3,
    y: 13,
    group: 'C'
  },
  {
    x: 7.8,
    y: 17.7,
    group: 'C'
  },
  {
    x: 7.6,
    y: 17.7,
    group: 'C'
  },
  {
    x: 14.4,
    y: 13.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 6.2,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.1,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 19.7,
    group: 'C'
  },
  {
    x: 11.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.2,
    y: 12.2,
    group: 'C'
  },
  {
    x: 9.8,
    y: 18.8,
    group: 'C'
  },
  {
    x: 11.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7.7,
    y: 13.1,
    group: 'C'
  },
  {
    x: 10.1,
    y: 18,
    group: 'C'
  },
  {
    x: 7.9,
    y: 17.2,
    group: 'C'
  },
  {
    x: 12.5,
    y: 13.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 12.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.2,
    group: 'C'
  },
  {
    x: 7.8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16.7,
    group: 'C'
  },
  {
    x: 11.2,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15,
    group: 'C'
  },
  {
    x: 5.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14,
    group: 'C'
  },
  {
    x: 8.4,
    y: 12.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16,
    group: 'C'
  },
  {
    x: 11.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.2,
    y: 12.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.3,
    group: 'C'
  },
  {
    x: 5.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 12.4,
    group: 'C'
  },
  {
    x: 8.8,
    y: 11.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.6,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 9.8,
    y: 12.6,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.3,
    group: 'C'
  },
  {
    x: 6.7,
    y: 13.3,
    group: 'C'
  },
  {
    x: 7.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 11.5,
    y: 15,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.9,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.3,
    y: 12.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.6,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.6,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.7,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 12.3,
    group: 'C'
  },
  {
    x: 11,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.7,
    y: 18.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 7.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.7,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 11.4,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.6,
    group: 'C'
  },
  {
    x: 7.9,
    y: 16,
    group: 'C'
  },
  {
    x: 6.3,
    y: 19.5,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.5,
    group: 'C'
  },
  {
    x: 12.2,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.2,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 18.7,
    group: 'C'
  },
  {
    x: 11,
    y: 16,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15,
    group: 'C'
  },
  {
    x: 9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 7,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 12.7,
    y: 13.9,
    group: 'C'
  },
  {
    x: 7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.2,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8,
    y: 18.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 14,
    group: 'C'
  },
  {
    x: 11.7,
    y: 17.1,
    group: 'C'
  },
  {
    x: 6.6,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.8,
    y: 13.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 16.8,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.5,
    group: 'C'
  },
  {
    x: 11.2,
    y: 16.1,
    group: 'C'
  },
  {
    x: 10.6,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 17.1,
    group: 'C'
  },
  {
    x: 8,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.4,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 8.7,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.4,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 14,
    group: 'C'
  },
  {
    x: 11.8,
    y: 16.2,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15,
    group: 'C'
  },
  {
    x: 6.6,
    y: 17.3,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 16,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.3,
    group: 'C'
  },
  {
    x: 13.4,
    y: 12.6,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.5,
    group: 'C'
  },
  {
    x: 12.4,
    y: 17.2,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.4,
    group: 'C'
  },
  {
    x: 10.5,
    y: 16,
    group: 'C'
  },
  {
    x: 9.9,
    y: 17.1,
    group: 'C'
  },
  {
    x: 10.7,
    y: 14.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.4,
    y: 13.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 5.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 11.3,
    y: 14.6,
    group: 'C'
  },
  {
    x: 7.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 18.3,
    group: 'C'
  },
  {
    x: 7.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.8,
    y: 17.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 18.2,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.7,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.5,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15,
    group: 'C'
  },
  {
    x: 9.9,
    y: 16.2,
    group: 'C'
  },
  {
    x: 11,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 12.7,
    y: 16.9,
    group: 'C'
  },
  {
    x: 7.2,
    y: 14.9,
    group: 'C'
  },
  {
    x: 6.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.6,
    group: 'C'
  },
  {
    x: 8.5,
    y: 14.7,
    group: 'C'
  },
  {
    x: 9,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.5,
    y: 13.8,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12,
    y: 17.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 5.1,
    y: 18.6,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.7,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 11.4,
    y: 17.6,
    group: 'C'
  },
  {
    x: 8,
    y: 13.4,
    group: 'C'
  },
  {
    x: 12.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 13.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 18.1,
    group: 'C'
  },
  {
    x: 9.9,
    y: 14.4,
    group: 'C'
  },
  {
    x: 9.5,
    y: 17.5,
    group: 'C'
  },
  {
    x: 9.9,
    y: 15,
    group: 'C'
  },
  {
    x: 7.1,
    y: 15.4,
    group: 'C'
  },
  {
    x: 9.7,
    y: 16.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.2,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.2,
    group: 'C'
  },
  {
    x: 9.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.5,
    y: 14.3,
    group: 'C'
  },
  {
    x: 9.2,
    y: 14.6,
    group: 'C'
  },
  {
    x: 12,
    y: 19.6,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 9.4,
    y: 18,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.1,
    group: 'C'
  },
  {
    x: 11.9,
    y: 18.7,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.7,
    group: 'C'
  },
  {
    x: 11.9,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 14.2,
    group: 'C'
  },
  {
    x: 11.2,
    y: 15.9,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 10.8,
    y: 11.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 12,
    y: 14.3,
    group: 'C'
  },
  {
    x: 10.6,
    y: 18.7,
    group: 'C'
  },
  {
    x: 10.2,
    y: 17,
    group: 'C'
  },
  {
    x: 10.1,
    y: 17.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 11.7,
    y: 14.9,
    group: 'C'
  },
  {
    x: 10.4,
    y: 10.6,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.4,
    y: 14.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.8,
    y: 14.9,
    group: 'C'
  },
  {
    x: 9.5,
    y: 13,
    group: 'C'
  },
  {
    x: 10.3,
    y: 14,
    group: 'C'
  },
  {
    x: 7.4,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.1,
    y: 17.8,
    group: 'C'
  },
  {
    x: 8.9,
    y: 16,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16,
    group: 'C'
  },
  {
    x: 11,
    y: 14.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.7,
    group: 'C'
  },
  {
    x: 10,
    y: 15,
    group: 'C'
  },
  {
    x: 7.7,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15,
    group: 'C'
  },
  {
    x: 8.7,
    y: 19,
    group: 'C'
  },
  {
    x: 9.1,
    y: 14.9,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.9,
    group: 'C'
  },
  {
    x: 8.1,
    y: 15.7,
    group: 'C'
  },
  {
    x: 6.7,
    y: 15.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.4,
    y: 14.5,
    group: 'C'
  },
  {
    x: 7.7,
    y: 12.6,
    group: 'C'
  },
  {
    x: 6.8,
    y: 15,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 17.3,
    group: 'C'
  },
  {
    x: 10.1,
    y: 16,
    group: 'C'
  },
  {
    x: 7.5,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.9,
    y: 16.4,
    group: 'C'
  },
  {
    x: 11.2,
    y: 14.5,
    group: 'C'
  },
  {
    x: 10.3,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 14,
    group: 'C'
  },
  {
    x: 9.4,
    y: 15,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.1,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.9,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.6,
    group: 'C'
  },
  {
    x: 11.1,
    y: 16.9,
    group: 'C'
  },
  {
    x: 8.4,
    y: 18.4,
    group: 'C'
  },
  {
    x: 7.6,
    y: 16.3,
    group: 'C'
  },
  {
    x: 7.6,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.8,
    y: 15.9,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.5,
    group: 'C'
  },
  {
    x: 8.6,
    y: 18.2,
    group: 'C'
  },
  {
    x: 8,
    y: 14.8,
    group: 'C'
  },
  {
    x: 10.5,
    y: 17,
    group: 'C'
  },
  {
    x: 6.7,
    y: 16.4,
    group: 'C'
  },
  {
    x: 10.8,
    y: 17.9,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.1,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.3,
    y: 19.1,
    group: 'C'
  },
  {
    x: 12.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 8.6,
    y: 15.8,
    group: 'C'
  },
  {
    x: 10.9,
    y: 15.7,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.6,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.8,
    group: 'C'
  },
  {
    x: 9.5,
    y: 15.5,
    group: 'C'
  },
  {
    x: 9.7,
    y: 14.5,
    group: 'C'
  },
  {
    x: 9.2,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.7,
    y: 16.3,
    group: 'C'
  },
  {
    x: 8,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.9,
    y: 18.3,
    group: 'C'
  },
  {
    x: 6.9,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.5,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 16.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 19.4,
    group: 'C'
  },
  {
    x: 11,
    y: 17.6,
    group: 'C'
  },
  {
    x: 10.8,
    y: 13.2,
    group: 'C'
  },
  {
    x: 8.9,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.4,
    y: 16.7,
    group: 'C'
  },
  {
    x: 10.3,
    y: 16.9,
    group: 'C'
  },
  {
    x: 9.6,
    y: 18,
    group: 'C'
  },
  {
    x: 8.8,
    y: 16.8,
    group: 'C'
  },
  {
    x: 8.5,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.4,
    y: 18.1,
    group: 'C'
  },
  {
    x: 8.8,
    y: 15.1,
    group: 'C'
  },
  {
    x: 7.5,
    y: 16.7,
    group: 'C'
  },
  {
    x: 9.1,
    y: 16.5,
    group: 'C'
  },
  {
    x: 11.6,
    y: 16.4,
    group: 'C'
  },
  {
    x: 9,
    y: 17,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13.6,
    group: 'C'
  },
  {
    x: 8.2,
    y: 13.8,
    group: 'C'
  },
  {
    x: 6.3,
    y: 15.6,
    group: 'C'
  },
  {
    x: 8.4,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.8,
    group: 'C'
  },
  {
    x: 10.1,
    y: 15.2,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.3,
    y: 14.4,
    group: 'C'
  },
  {
    x: 5.5,
    y: 15.2,
    group: 'C'
  },
  {
    x: 8.7,
    y: 16,
    group: 'C'
  },
  {
    x: 9.1,
    y: 13.3,
    group: 'C'
  },
  {
    x: 8.6,
    y: 14.8,
    group: 'C'
  },
  {
    x: 8.7,
    y: 14.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 11.5,
    y: 13.5,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 10.5,
    y: 15.8,
    group: 'C'
  },
  {
    x: 11.9,
    y: 16.5,
    group: 'C'
  },
  {
    x: 10.1,
    y: 14.7,
    group: 'C'
  },
  {
    x: 7.7,
    y: 18,
    group: 'C'
  },
  {
    x: 9.6,
    y: 16.2,
    group: 'C'
  },
  {
    x: 12.2,
    y: 13.5,
    group: 'C'
  },
  {
    x: 9,
    y: 16,
    group: 'C'
  },
  {
    x: 8.3,
    y: 15,
    group: 'C'
  },
  {
    x: 11,
    y: 14.3,
    group: 'C'
  },
  {
    x: 8.5,
    y: 12.8,
    group: 'C'
  },
  {
    x: 9.2,
    y: 13.3,
    group: 'C'
  },
  {
    x: 6.6,
    y: 13.4,
    group: 'C'
  },
  {
    x: 8.6,
    y: 12.3,
    group: 'C'
  },
  {
    x: 10.2,
    y: 15.6,
    group: 'C'
  },
  {
    x: 12.2,
    y: 15.4,
    group: 'C'
  },
  {
    x: 8.3,
    y: 16.3,
    group: 'C'
  },
  {
    x: 11.4,
    y: 15.4,
    group: 'C'
  },
  {
    x: 10.7,
    y: 15.3,
    group: 'C'
  },
  {
    x: 9.1,
    y: 15.3,
    group: 'C'
  },
  {
    x: 8.1,
    y: 13,
    group: 'C'
  },
  {
    x: 10.1,
    y: 12.5,
    group: 'C'
  }
];
